export const DEFAULT_PAGE_SIZE = 20;

export const PAGE_SIZE_OPTIONS = [40, 50, 100, 200, 500, 1000];

/** For dropdowns / Redux reference data — fetch all records in one request */
export const REFERENCE_DATA_PAGE_SIZE = 1000;

export const parsePaginatedResponse = (response) => {
  if (response && Array.isArray(response.results)) {
    return {
      items: response.results,
      totalCount: response.count ?? response.results.length,
    };
  }
  const items = Array.isArray(response) ? response : [];
  return { items, totalCount: items.length };
};
